import type { FieldOptions } from '../types';

export function stringValidation(options: FieldOptions, value: string) {
  const { type, choices, regex, regexMatchFaulty, maxLength, minLength } = options;

  if (type === 'alphaNumericDash' && !/^[\w-]*$/.test(value)) {
    return 'Only numbers letters, underscore and dashes are allowed';
  }

  if (type === 'url') {
    try {
      // eslint-disable-next-line no-new
      new URL(value);
    } catch (e) {
      return 'The URL is formatted incorrectly.';
    }
  }

  if (type === 'httpUrl') {
    try {
      // eslint-disable-next-line no-new
      const url = new URL(value);
      if (!['http:', 'https:'].includes(url.protocol)) {
        return 'no http(s) protocol';
      }
      if (!url.hostname.includes('.')) {
        return 'tld only host is not accepted';
      }
    } catch (e) {
      return 'The URL is formatted incorrectly.';
    }
  }

  if (type === 'enum' && choices && !choices.includes(value)) {
    return 'not included in enum';
  }

  // check values
  if (regex && !regex.test(value)) {
    return 'Does not match the required format';
  }

  if (regexMatchFaulty && value.match(regexMatchFaulty)) {
    const faultyCharacters = value.match(regexMatchFaulty);

    return `Cannot contain the following characters: ${faultyCharacters}`;
  }

  if (maxLength && value.length > maxLength) {
    return `Maximum length is ${maxLength}`;
  }
  if (minLength && value.length < minLength) {
    return `Minimum length is ${minLength}`;
  }

  return false;
}
